import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import MenuPage from './MenuPage';
import Footer from './Footer';

const { ace } = window;

const serverUrl = 'https://ihongss.com';

const ListPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.AuthReducer);
    const [docs, setDocs] = useState([]);
    const [activePid, setActivePid] = useState(null);

    const nl2br = (str, is_xhtml) => {
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    };

    const handleContent = async (pid) => {
        setActivePid(pid);
        sessionStorage.setItem("PID", pid);

        const url = `${serverUrl}/api/member/ebook_file_data_list.json?tree_node_id=${pid}`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const { data } = await axios.get(url, { headers });

        if (data.status === 200) {
            var cnt = -1;
            var editor = [];

            const contentData = document.getElementById('content_data');
            contentData.innerHTML = "";

            for (let i = data.docs.length - 1; i >= 0; i--) {
                const mode = data.docs[i].editor_mode;

                if (mode.startsWith('ace')) {
                    if (mode.endsWith('text')) {
                        const textDiv = document.createElement('div');
                        textDiv.style.padding = '10px';
                        const paragraph = document.createElement('p');
                        paragraph.innerHTML = nl2br(data.docs[i].editor_data);
                        textDiv.appendChild(paragraph);
                        contentData.appendChild(textDiv);
                    }

                    else if (mode.endsWith('markdown')) {
                        const html = window.marked.parse(data.docs[i].editor_data);
                        const markdownId = `markdown_${cnt}`;
                        const markdownDiv = document.createElement('div');
                        markdownDiv.id = markdownId;
                        markdownDiv.className = 'markdown-body';
                        markdownDiv.innerHTML = html;
                        markdownDiv.style.padding = '10px';
                        contentData.appendChild(markdownDiv);

                        setTimeout(() => {
                            window.Prism.highlightAll();
                        }, 0);

                        document.querySelectorAll(`#${markdownId} pre code.language-mermaid`).forEach((element) => {
                            const code = element.textContent;
                            const pre = element.parentElement;

                            const mermaidDiv = document.createElement('div');
                            mermaidDiv.className = 'mermaid';
                            mermaidDiv.textContent = code;

                            pre.replaceWith(mermaidDiv);
                        });
                    }
                    else {
                        cnt++;

                        const editorContainer = document.createElement('div');

                        editorContainer.style.display = "inline-block";
                        editorContainer.style.width = "100%";
                        editorContainer.style.padding = "10px";

                        const editorDiv = document.createElement('div');

                        editorDiv.id = `editor_${cnt}`;
                        editorDiv.style.marginTop = "0px";
                        editorContainer.appendChild(editorDiv);

                        const htmlHr = document.createElement('hr');
                        editorContainer.appendChild(htmlHr);

                        contentData.appendChild(editorContainer);

                        editor[cnt] = ace.edit(`editor_${cnt}`, {
                            theme: "ace/theme/eclipse",
                            mode: data.docs[i].editor_mode,
                            maxLines: Infinity,
                            wrap: true,
                            fontSize: "17px",
                            autoScrollEditorIntoView: true
                        });

                        editor[cnt].setValue(data.docs[i].editor_data);
                        editor[cnt].gotoLine(0, 0);
                        editor[cnt].setReadOnly(true);
                        editor[cnt].setHighlightActiveLine(false);
                        editor[cnt].setHighlightGutterLine(false);
                        editor[cnt].renderer.$cursorLayer.element.style.display = "none";
                    }
                } else if (mode === 'tag_file') {
                    const htmlDiv = document.createElement('div');
                    htmlDiv.style.display = "inline-block";
                    htmlDiv.style.width = "100%";
                    htmlDiv.style.padding = "10px";

                    const img = document.createElement('img');

                    img.classList.add('img-fluid');
                    img.style.border = "1px solid #cccccc";
                    img.style.boxSizing = "border-box";
                    img.style.maxWidth = "100%";
                    img.style.height = "auto";

                    img.id = `image_view_${cnt}`;
                    if (data.docs[i].editor_data !== "") {
                        img.src = data.docs[i].editor_data;
                    } else {
                        img.src = `${process.env.PUBLIC_URL}/default.jpeg`;
                    }
                    htmlDiv.appendChild(img);

                    const htmlHr = document.createElement('hr');
                    htmlDiv.appendChild(htmlHr);

                    contentData.appendChild(htmlDiv);
                }
            }

            window.mermaid.run();
        }

        else if (data.status < 0) {
            dispatch({ type: 'logout' });
            navigate(`/`);
        }
    };


    const handleData = useCallback(async () => {
        var pid = sessionStorage.getItem("PID");

        const url = `${serverUrl}/api/member/course_file_list.json?sort=1`;
        const headers = { "Content-Type": "application/json", "auth": token };
        const { data } = await axios.get(url, { headers });

        if (data.status === 200) {
            if (data.result.length > 0) {
                setDocs(data.result);
                if (pid === null) {
                    pid = data.result[0].tree_node_id;
                }
                setActivePid(pid);
                sessionStorage.setItem("PID", pid);
                handleContent(pid);
            }
        }
        else if (data.status < 0) {
            dispatch({ type: 'logout' });
            navigate(`/`);
        }
    }, [token, navigate, dispatch]);

    useEffect(() => {
        handleData();
    }, [token, handleData]);

    return (
        <div>
            <div className="card flex justify-content-center"
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1000,
                    background: '#f0f2f5',
                    paddingTop: '5px',
                    paddingBottom: '2px',
                }}
            >
                <div>
                    <MenuPage />
                </div>

                <hr />
            </div>

            <div style={{ width: '100%', padding: '0 0px', boxSizing: 'border-box' }}>
                <div style={{ display: 'flex', width: '100%', alignItems: 'flex-start' }}>

                    <div style={{ width: '80%', paddingRight: '20px' }}>
                        <div id="content_data" style={{ backgroundColor: '#ffffff', padding: '10px', minHeight: '500px' }}>
                            <p>강의 자료가 없습니다.</p>
                        </div>
                    </div>

                    <div style={{
                        width: '20%',
                        paddingLeft: '20px',
                        borderLeft: '1px solid #e0e0e0',
                        position: 'sticky',
                        top: '78px', 
                        maxHeight: 'calc(100vh - 110px)', 
                        overflowY: 'auto'
                    }}>
                        <div style={{ background: '#ffffff', padding: '10px 5px' }}>
                            {
                                docs?.length > 0 && docs.map((item, index) => (
                                    <p key={item._id} style={{
                                        margin: '0',
                                        padding: '8px 10px',
                                        borderRadius: '4px',
                                        backgroundColor: activePid === item.tree_node_id ? '#e8f5e9' : 'transparent'
                                    }}>
                                        <Link
                                            style={{
                                                textDecoration: 'none',
                                                color: activePid === item.tree_node_id ? '#2e7d32' : '#333333',
                                                fontWeight: activePid === item.tree_node_id ? 'bold' : 'normal',
                                                display: 'block'
                                            }}
                                            onClick={() => { handleContent(item.tree_node_id) }}
                                        >
                                            {index +1}. {item.title ?? '제목 없음'}
                                        </Link>
                                    </p>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default ListPage;